<template>
  <div v-intersect.once="handleIntersect">
    <div v-if="hasIntersected">
      <div class="m-fundraising__values">
        <div class="m-fundraising__total">
          <ICountUp :endVal="total" :duration="2.7" :options="{ prefix: '£' }" />
        </div>
        <div class="m-fundraising__of">of</div>
        <div class="m-fundraising__target">
          £{{ target }}
        </div>
      </div>
      <div class="m-fundraising__progress-bar" v-if="total > 0">
        <div class="m-fundraising__progress-bar-fill" :style="{ width: `${Math.min((total / target) * 100, 100)}%` }"></div>
      </div>
      <div class="m-fundraising__target-text" v-if="targetReached">
        Thank you for your support
      </div>
      <div class="m-fundraising__target-text" v-else>
        Help us reach our target
      </div>
    </div>
  </div>
</template>
<script>

import { filter, includes } from 'lodash'
import axios from 'axios';
import ICountUp from 'vue-countup-v2';
export default {
  props: {
    url: {
      type: String,
      default: 'https://www.exodusonline.app'
    },
    token: {
      type: String,
      default: ''
    },
    initialTarget: {
      type: Number,
      default: 0
    },
    initialTotal: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      target: this.initialTarget,
      total: this.initialTotal,
      hasIntersected: false,
    }
  },
  directives: {
    intersect: {
      inserted(el, binding, vnode) {
        const callback = binding.value;
        const options = {
          root: null,
          threshold: 0
        };
        let observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              callback();
              observer.unobserve(entry.target);
            }
          });
        }, options);
        observer.observe(el);
      }
    }
  },
  methods: {
    handleIntersect() {
      if (!this.hasIntersected) {
        this.hasIntersected = true;
        this.fetchFundraisingValues();
      }
    },
    fetchFundraisingValues() {
      axios.post(`${this.url}/api/groups/details`,
        {
          token: this.token
        }, {
          headers: {
            'Content-Type': 'application/json',
          }
        })
        .then(response => {
          if (response.status === 200) {
            this.target = parseInt(response.data.target);
            this.total = parseInt(response.data.total);
          }
        });
    }
  },
  mounted() {
    // Do not fetch on mount; handled via intersection
  },
  components: {
    ICountUp
  },
  computed: {
    targetReached() {
      return this.total >= this.target;
    }
  },
}
</script>

